import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updatePassword, verifyLink } from "./getapi";
import Header from "./Header";
import LoadingSpinner from "../../components/LoadingSpinner";

const LinkExpiry = (req, res) => {
  const [isExpired, setExpiry] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(true);
  const [formValue, setFormValue] = useState({
    confirmPassword: "",
    confirmPassword1: "",
    otp: "",
  });
  const { confirmPassword, confirmPassword1, otp } = formValue;
  const handleChange = (name) => (e) => {
    console.log(name, e);
    setFormValue({ ...formValue, [name]: e.target.value });
  };
  let Navigate = useNavigate();

  const handleSubmit = async (e) => {
    console.log(formValue);
    e.preventDefault();

    if (
      confirmPassword &&
      confirmPassword1 &&
      confirmPassword === confirmPassword1 &&
      otp.length == 4
    ) {
      setIsLoading(true);
      try {
        const a = await updatePassword(userId, { confirmPassword, otp });
        console.log(a);
        if (a?.error) {
          alert(a.error);
          return false;
        }
        if (a?.errormessage) {
          alert(a?.errormessage);
          return false;
        }
        if (a?.message) {
          alert(a?.message);
          Navigate("/signin");
        }
      } catch (e) {
        alert("Failed to fetch data.Please try again later");
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Enter valid credentials");
      return false;
    }
  };

  const { userId, uid } = useParams();
  useEffect(() => {
    setIsVerifying(true);
    verifyLink(userId, uid)
      .then((data) => {
        if (data.result) {
          setExpiry(data.result);
        }
        if (data.errorMessage) {
          alert(data.errorMessage);
          return false;
        }
        if (data.error) {
          setExpiry(true);
        }
      })
      .catch((e) => {
        alert("Failed to fetch data");
        return false;
      })
      .finally(() => {
        setIsVerifying(false);
      });
  }, [userId, uid]);
  return (
    <>
      <Header />
      <br />
      {isVerifying ? (
        <center>
          <LoadingSpinner
            size="2x"
            color="#E34607"
            text="Verifying reset link..."
            showText={true}
          />
        </center>
      ) : isExpired ? (
        <>
          <center>
            <h2 style={{ color: "#E34607" }}>Link is expired</h2>
            <p>
              This password reset link has expired. Please request a new one.
            </p>
            <button
              type="button"
              onClick={() => Navigate("/signin")}
              className="btn btn-info"
              style={{ margin: "15px", backgroundColor: "#E34607" }}
            >
              Back to Sign In
            </button>
          </center>
        </>
      ) : (
        <>
          <center>
            <h2 style={{ color: "#E34607" }}>Confirm Password</h2>
            <form className="col-sm-4">
              <div className="form-group">
                <input
                  type="number"
                  name="otp"
                  onChange={handleChange("otp")}
                  value={otp}
                  placeholder="Enter OTP"
                  className="form-control"
                  style={{ borderRadius: "15px 15px 15px 15px" }}
                />
              </div>
              <br />
              <div className="form-group">
                <input
                  type="password"
                  name="confirmPassword"
                  onChange={handleChange("confirmPassword")}
                  value={confirmPassword}
                  placeholder="Enter password"
                  className="form-control"
                  style={{ borderRadius: "15px 15px 15px 15px" }}
                />
              </div>
              <br />
              <div className="form-group">
                <input
                  type="password"
                  name="confirmPassword1"
                  onChange={handleChange("confirmPassword1")}
                  value={confirmPassword1}
                  placeholder="Re-type password"
                  className="form-control"
                  style={{ borderRadius: "15px 15px 15px 15px" }}
                />
              </div>
              <br />
            </form>
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-info"
              style={{ margin: "15px", backgroundColor: "#E34607" }}
              disabled={isLoading}
            >
              {isLoading ? (
                <LoadingSpinner
                  size="1x"
                  color="#fff"
                  text="Updating Password..."
                  showText={true}
                />
              ) : (
                "Save Password"
              )}
            </button>
          </center>
        </>
      )}
    </>
  );
};

export default LinkExpiry;
